/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';

import { LayoutComponent_Button as LayoutComponentButton } from 'ggApp/modules/layout';
import { Translator } from 'ggApp/modules/translator/components';

import styles from './index.module.scss';

export default class FormsPhoneVerificationUpdatePhone extends PureComponent {
    render() {
        const {
            updatePhone,
            authFetching,
            authReset,
            resetAsyncValidation,
            reqMark,
            dark,
            phonePrefixes,
            authPhoneVerification,
            disabled,
            phone: { code, number, isVerified },
        } = this.props;

        const asyncError = authPhoneVerification.asyncErrors.updatePhoneError;
        const errorCondition =
            !!asyncError ||
            (code.meta.touched && !!code.meta.error) ||
            (number.meta.touched && !!number.meta.error) ||
            (isVerified.meta.touched && !!isVerified.meta.error);
        const buttonValid = !asyncError || (code.meta.valid && number.meta.valid);

        return (
            <div
                className={`${styles.formsPhoneVerificationUpdatePhone} ${
                    disabled ? styles['formsPhoneVerificationUpdatePhone--disabled'] : ''
                } ${dark ? styles['formsPhoneVerificationUpdatePhone--dark'] : ''}`}
            >
                <div className={styles.formsPhoneVerificationUpdatePhone__tip}>
                    <Translator tk="PHONE_VERIFICATION_TIP" />
                </div>
                <div className={styles.formsPhoneVerificationUpdatePhone__wrap}>
                    <div className={styles.formsPhoneVerificationUpdatePhone__boxWrap}>
                        <div
                            className={
                                ('formsPhoneVerificationUpdatePhone__box',
                                {
                                    active: code.meta.active || code.input.value.length !== 0,
                                    error: !!asyncError || (code.meta.touched && !!code.meta.error),
                                    valid: !asyncError && code.meta.valid,
                                })
                            }
                        >
                            <div className={styles.formsPhoneVerificationUpdatePhone__label}>
                                <div>
                                    <Translator tk="FORM_LABEL_PHONE_PREFIX" /> {reqMark ? '*' : ''}
                                </div>
                            </div>
                            <select
                                id="phoneNumberPrefixSelect"
                                {...code.input}
                                onChange={(e) => {
                                    resetAsyncValidation({ updatePhoneError: '' });
                                    code.input.onChange(e.target.value);
                                }}
                            >
                                {phonePrefixes.map((pp, i) => (
                                    <option key={i} value={pp.id}>
                                        {pp.id}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div
                            className={
                                ('formsPhoneVerificationUpdatePhone__box',
                                {
                                    input: true,
                                    active: number.meta.active || number.input.value.length !== 0,
                                    error:
                                        !!asyncError ||
                                        (number.meta.touched && !!number.meta.error),
                                    valid: !asyncError && number.meta.valid,
                                })
                            }
                        >
                            <div className={styles.formsPhoneVerificationUpdatePhone__label}>
                                <div>
                                    <Translator tk="FORM_LABEL_PHONE_NUMBER" /> {reqMark ? '*' : ''}
                                </div>
                            </div>
                            <input
                                id="phoneNumberInput"
                                {...number.input}
                                type="text"
                                onChange={(e) => {
                                    resetAsyncValidation({ updatePhoneError: '' });
                                    number.input.onChange(e.target.value.replace(/\D/g, ''));
                                }}
                            />
                        </div>
                    </div>
                    <LayoutComponentButton
                        dark={dark}
                        className={styles.formsPhoneVerificationUpdatePhone__button}
                        disabled={!buttonValid || authPhoneVerification.progress}
                        autoWidth
                        noArrow
                        inputSize
                        noBorderMobile
                        tk="VERIFY"
                        type="button"
                        loading={authFetching}
                        onClick={() => updatePhone(code.input.value, number.input.value)}
                    />
                </div>
                {errorCondition && !authPhoneVerification.progress && (
                    <div className={styles.formsPhoneVerificationUpdatePhone__error}>
                        {asyncError || (
                            <Translator
                                tk={code.meta.error || number.meta.error || isVerified.meta.error}
                            />
                        )}
                    </div>
                )}
                {authPhoneVerification.progress && (
                    <div className={styles.formsPhoneVerificationUpdatePhone__editer}>
                        <div
                            onClick={() => {
                                updatePhone(code.input.value, number.input.value);
                            }}
                        >
                            <Translator tk="PHONE_VERIFICATION_RESEND_CODE" />
                        </div>
                        <div onClick={authReset}>
                            <Translator tk="PHONE_VERIFICATION_EDIT_PHONE" />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
